<template>
  <div class="container">
    <div class="top-info">
      <!-- <img src="../../assets/images/banner_bg.png" alt="" class="banner"> -->
      <div class="info-container">
        <div class="user">
          <img class="avatar" :src="userInfo.avatar | default_img" alt="" />
          <div class="info">
            <div class="name">{{ userInfo.nickname || userInfo.username }}</div>
            <div class="job-location flex align-center margin-top-10">
              <img src="../../assets/images/user/job.png" />
              <span class="margin-right-10">{{ userInfo.job }}Fashion Designer</span>
              <template  v-if="userInfo.city">
                <img src="../../assets/images/user/location.png" />
                <span>{{ userInfo.city }}</span>
              </template>
            </div>
            <div class="fans-info margin-top-10">
              <span class="margin-right-20">{{ userInfo.follow_count }} Followers</span>
              <span class="margin-right-20">{{ userInfo.fans_count }} Following</span>
              <span class="margin-right-20">{{userInfo.cz_count}} Likes</span>
            </div>
          </div>
        </div>
        <div class="btn-box flex align-center justify-center">
          <img src="../../assets/images/user/icon_share.png" style="width:22px;height:22px;margin-right:5px;" />
          <span class="text-black" @click="onShareClick">Share my homepage</span>
          
        </div>
      </div>
    </div>

    <div class="btn-container">
      <div class="design" @click="start_draft">
        <div class="content">
          <img src="../../assets/images/user/icon-design.png"  />
          <div class="title">Create clothing style design</div>
          <div class="desc">Upload design drawings, customize and produce clothing online</div>
          <div class="btn">
            Start Design
          </div>
        </div>
        <img src="../../assets/images/user/design-bg.png" class="bg" />
      </div>
      <div class="add-post"  @click="onCreatePosts(1)">
        <div class="content">
           <img src="../../assets/images/user/icon-post.png"  />
          <div class="title">Create a post</div>
          <div class="desc">Upload pictures or videos, and post your own posts</div>
          <div class="btn">
            Start creating
          </div>
        </div>
        <img src="../../assets/images/user/post-bg.png" class="bg" />
      </div>
      
    </div>

    <div class="tool-wrap">
      <div class="tabs-box">
        <div
          class="tabs-item"
          :class="[selected_tab == 1 ? 'active' : '']"
          @click="onTabClick(1)"
        >
          Design Record
        </div>
        <div
          class="tabs-item"
          :class="[selected_tab == 2 ? 'active' : '']"
          @click="onTabClick(2)"
        >
          My Collection
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="search"
          v-model="form_data.keyword"
          class="input"
          @keyup.enter="onSearch"
        />
        <img
          src="../../assets/images/icon-search-workbench.png"
          alt=""
          class="icon-search cursor"
          @click="onSearch"
        />
      </div>
    </div>
    <!-- <h3 class="title">作图记录</h3> -->
    <template v-if="selected_tab == 1 && draft_list.length > 0">
      <div class="list">
        <div
          class="item"
          v-for="(v, k) in draft_list"
          :key="`d` + k"
          @click="edit(v.uuid)"
        >
          <img :src="v.image | default_img" alt="" class="image" />
          <div class="name">{{ v.name }}</div>
          <div class="time">{{ v.update_time | enDate}}</div>
          <div class="mask">
          
            <img
              src="../../assets/images/user/icon_edit_design.png"
              alt=""
              class="icon-edit"
              @click.stop="edit(v.uuid)"
            />
            <img
              src="../../assets/images/user/icon_delete_design.png"
              alt=""
              class="icon-delete"
              @click.stop="del(v.uuid)"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="selected_tab == 2 && infiniteList.length > 0">
      <div
        class="masonry-container"
        style="margin-top: 30px; padding-bottom: 70px"
      >
        <masonry
          :cols="{ default: 6, 1600: 5, 1300: 5, 700: 3, 400: 2 }"
          :gutter="{ default: '30px', 1300: '20px', 700: '15px', 400: '10px' }"
        >
          <div
            v-for="(item, index) in infiniteList"
            :key="index"
            @click.prevent.stop="onArticleDetail(item)"
          >
            <template>
              <div class="masonry-item">
                <img
                  v-if="item.type == 2"
                  src="../../assets/images/icon-play.png"
                  class="play-btn"
                  alt=""
                />
                <!-- <img src="../../assets/images/icon-match-on-list.png" class="match-ico" /> -->
                <div
                  class="remove-collect"
                  @click.prevent.stop="onCollectRemove(item)"
                >
                  Remove<Icon type="md-close"></Icon>
                </div>
                <div class="img-container">
                  <img
                    :src="item.cover"
                    @load="onImageLoad"
                    class="masonry-image"
                  />
                </div>
                <div class="item-content">
                  <div class="title">{{ item.title }}</div>
                  <div class="bottom-box">
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-views-workbench-list.png"
                      />
                      <div style="margin-left: 3px">{{ item.view_times }}</div>
                    </div>
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-comment-workbench-list.png"
                      />
                      <div style="margin-left: 3px">
                        {{ item.comment_count }}
                      </div>
                    </div>
                    <div class="bottom-item">
                      <img
                        src="../../assets/images/icon-collect-workbench-list.png"
                      />
                      <div style="margin-left: 3px">{{ item.zan_count }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </masonry>
      </div>
    </template>
    <template v-else>
      <img
        src="../../assets/images/no-data.png"
        style="width: 300px; display: block; margin: 0 auto"
        alt=""
      />
    </template>
    <div class="kefu-box" @click="showChat()" v-show="false">
      <div class="kefu-item">
        <img src="../../assets/images/chat/xiaoxi.png" class="kefu" />
        <div class="badge" v-if="messageNum > 0">{{ messageNum }}</div>
      </div>
      <!-- <div class="kefu-item">
				<img src="../../assets/images/chat/kefu.png" class="kefu" />
			</div> -->
    </div>
    <img
      v-show="isBackToTopVisible"
      src="../../assets/images/icon-to-top.png"
      @click="scrollToTop"
      class="scroll-top"
      ref="backToTop"
    />
    <chat ref="chat"></chat>
    <!-- 帖子详情 -->
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="article_id"
    ></ArticleDetail>
    <!-- 发布笔记 -->
    <create-posts
      ref="createPop"
      v-if="show_creator_pop"
      @close-upload-pop="show_creator_pop = false"
      :incomeType="create_type"
    />
  </div>
</template>

<script>
import { GetAllNoRedNum } from "@/api/chat.js";
import { DeleteDraft, DraftList, Profile } from "@/api/index.js";
import { GetMyCollectList, PostsCollect } from "@/api/social";
import ArticleDetail from "@/components/ArticleDetail";
import Chat from "@/components/Chat.vue";
import CreatePosts from "@/components/CreatePosts.vue";
import infiniteMix from "@/mixins/infinite";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "WorkbenchHome",
  components: {
    Chat,
    ArticleDetail,
    CreatePosts,
  },
  mixins: [infiniteMix],
  data() {
    return {
      form_data: {
        keyword: "",
      },
      draft_list: [],
      messageNum: 0,
      selected_tab: 1,
      isBackToTopVisible: false,
      collect_count: 0,
      show_detail: false,
      show_creator_pop: false,
      create_type: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
    is_login() {
      return this.$store.state.is_login;
    },
  },
  async mounted() {
    await this.$store.dispatch("getUser");
    window.addEventListener("scroll", this.handleScroll);
    axios
      .all([this.getProfile(), this.getDraftList()])
      .then(axios.spread(() => {}));
    this.getAllNoRedNum();
    this.getInfiniteList(true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onSearch() {
      const { selected_tab } = this;
      switch (selected_tab) {
        case 1:
          this.getDraftList();
          break;
        case 2:
          this.getInfiniteList(true);
          break;
      }
    },
    async onShareClick() {
      const text = `${window.location.origin}/shop/home?uid=${
        this.userInfo.code
      }`;
      console.log('text==>clipboard',text);
      await navigator.clipboard.writeText(text);
      this.$layer.msg("Copied successfully");
      // return;
      this.$router.push({
        name: "ShopHome",
        query: { uid: this.userInfo.code },
      });
    },
    onCreatePosts(type) {
      if (!this.is_login) {
        this.$router.replace({ name: "Login" });
        return;
      }
      this.create_type = type;
      this.show_creator_pop = true;
      // console.log('ref',this.$refs.createPop);
      // console.log(type);
    },
    onCloseArticleDetail() {
      this.show_detail = false;
    },
    onTabClick(type) {
      this.selected_tab = type;
      if (type == 1) {
        this.getDraftList();
      } else {
        this.getInfiniteList(true);
      }
    },
    async getInfiniteData(pageIndex, pageSize) {
      try {
        const { keyword } = this.form_data;
        const { data } = await GetMyCollectList({
          page: pageIndex,
          limit: pageSize,
          keyword,
        });
        const res = {};
        if (!data) {
          res.data = [];
          return res;
        }
        this.collect_count = data.count;
        res.data = data.list ? data.list : [];
        console.log("res", res);
        return res;
      } catch (e) {
        console.log("infiniteList", e);
        const res = {};
        res.data = [];
        return res;
      }
    },
    handleScroll: _.debounce(function() {
      this.isBackToTopVisible = window.pageYOffset > 300; // Show when scrolled over 300px

      // Load more when reaching bottom
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      if (
        scrollTop + windowHeight >= documentHeight - 100 &&
        this.selected_tab === 2 &&
        !this.infiniteEnded
      ) {
        this.getInfiniteList();
      }
    }, 200),
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    onArticleDetail(item) {
      console.log("aaa-click", item);
      this.article_id = item.uuid;
      this.show_detail = true;
    },
    async onCollectRemove(item) {
      console.log("remove-item", item);
      try {
        await PostsCollect({ uuid: item.uuid });
        this.$layer.msg("Successfully removed from favorites");
        this.getInfiniteList(true);
      } catch (e) {
        console.log("Exception when removing from favorites", e);
      }
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    start_draft() {
      let route = this.$router.resolve({ name: "WorkBenchDesign" });
      window.open(route.href, "_blank");
    },
    edit(uuid) {
      let route = this.$router.resolve({
        name: "WorkBenchDesign",
        query: { uuid },
      });
      window.open(route.href, "_blank");
    },
    del(uuid) {
      this.$DModal.confirm({
        content: "Confirm to delete this design record?",
        okText:'Confirm',
        cancelText:'Cancel',
        onOK: () => {
          DeleteDraft({ uuid })
            .then(() => {
              this.$layer.msg(`Operation successful`);
            })
            .finally(() => {
              this.getDraftList();
            });
        },
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getDraftList() {
       const { keyword } = this.form_data;
      return DraftList({
        page: 1,
        limit: 10,
        keyword,
      }).then((response) => {
        this.draft_list = response.data;
        return response;
      });
    },
    showChat() {
      this.$refs["chat"].showChat();
    },
    async getAllNoRedNum() {
      let { data } = await GetAllNoRedNum();
      this.messageNum = data.chatNum;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 70px 0 30px;
  background: white;
  text-align: left;
  .scroll-top {
    position: fixed;
    bottom: 130px;
    right: 34px;
    width: 46px;
    height: 46px;
    cursor: pointer;
  }

  .info-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    .user {
      display: flex;
      align-items: center;
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 20px;
        object-fit: cover;
      }
      .info {
        .name {
          color: #1f1f1f;
          font-size: 20px;
        }
        .job-location {
          color: #2b2b2b;
          font-size: 12px;
          img {
            width: 19px;
            height: 19px;
            margin-right: 2px;
          }
          span {
            color: #808080;
          }
        }
        .fans-info {
          color: #808080;
          font-size: 14px;
        }
      }
    }
    .btn-box {
      font-size: 14px;
      border-radius: 10px;
      width: 200px;
      height: 48px;
      background: #ffffff;
      border-radius: 24px 24px 24px 24px;
      border: 1px solid #e0e0e0;
      cursor:pointer;
    }
  }
  .btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 35px;
    height: 200px;
    background: #ffffff;
    .design,
    .add-post {
      flex: 1 0 720px;
      height: 100%;
      border: 1px solid #e6e6e6;
      border-radius: 22px;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      display: flex;
      align-content: space-between;
      align-items: center;
      padding: 20px;

      .bg {
        width: 468px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .content {
        img {
          width: 35px;
          height: 35px;
        }
        .title {
          font-size: 18px;
          line-height: 18px;
          color: black;
          font-weight: bold;
          margin-top: 20px;
        }
        .desc {
          margin-top: 10px;
          font-size: 14px;
          line-height: 14px;
          color: #808080;
          margin-bottom: 25px;
        }

        .btn {
          font-size: 14px;
          color: #000000;
          font-weight: bold;
        }
      }
    }
  }

  .tool-wrap {
    display: flex;
    justify-content: space-between;
    // margin: 40px 0 10px 0;
    margin-top: 40px;
    .tabs-box {
      display: flex;
      align-items: center;
      .tabs-item {
        width: 130px;
        height: 36px;
        line-height: 36px;
        background: #ffffff;
        border-radius: 18px;
        margin-right: 30px;
        font-size: 14px;
        color: #000000;
        text-align: center;
        cursor: pointer;
        font-weight: bold;
        &.active {
          background: #f8f7f4;
        }
        span {
          font-size: 16px;
        }
      }
    }
    .search {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f3f3f6;
      width: 300px;
      height: 45px;
      border-radius: 23px;
      .icon-search {
        width: 20px;
        height: 20px;
        margin-right: 20px;
      }
      .input {
        width: calc(100% - 40px);
        height: 100%;
        line-height: 50px;
        border-radius: 25px;
        padding-left: 20px;
        padding-right: 10px;
        background: #f3f4f6;
        font-size: 14px;
        outline: none;
        border: none;
      }
    }
  }

  .title {
    color: #68696a;
    font-size: 18px;
  }

  .list {
    padding: 30px 0 80px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item {
      position: relative;
      width: 270px;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;
      .image {
        width: 270px;
        height: 270px;
        object-fit: cover;
        border-radius: 5px;
        border: 1px solid #ebedf2;
      }
      .name {
        margin-top: 10px;
        font-size: 16px;
        line-height: 16px;
        color: #000000;
      }
      .time {
        margin-top: 10px;
        font-size: 12px;
        color: #999999;
      }
      .mask {
        display: none;
      }
      &:hover {
        .mask {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 270px;
          z-index: 100;
          background: rgba(0, 0, 0, 0.35);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon-mag {
            position: absolute;
            width: 40px;
            height: 40px;
            top: 96px;
            left: 99px;
          }
          .icon-edit {
            width: 25px;
            height: 23px;
            top: 11px;
            right: 47px;
          }
          .icon-delete {
            position: absolute;
            width: 34px;
            height: 34px;
            bottom: 11px;
            right: 11px;
          }
        }
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
  .kefu-box {
    position: fixed;
    top: 500px;
    right: 5px;
    .kefu-item {
      position: relative;
      margin-bottom: 10px;
      width: 70px;
      height: 70px;
      background: #ffffff;
      box-shadow: 0px 0px 5px 0px #cbc5c5;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .kefu {
        width: 60px;
        height: 60px;
      }
      .badge {
        background-color: #f34d37;
        border-radius: 10px;
        color: #fff;
        display: inline-block;
        font-size: 12px;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        text-align: center;
        white-space: nowrap;
        border: 1px solid #fff;
        position: absolute;
        top: -5px;
        right: -5px;
      }
    }
  }

  /**瀑布流样式开始 */
  .masonry-container {
    max-width: 1520px;
    margin: 0 auto;
    .masonry-item {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      width: 236px;
      cursor: pointer;
      position: relative;
      .remove-collect {
        display: none;
      }
      &:hover .remove-collect {
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        color: white;
        font-size: 14px;
        line-height: normal;
        padding: 4px 14px;
        border-bottom-right-radius: 10px;
        border-top-left-radius: 10px;
        display: flex;
        align-items: center;
        z-index: 10;
      }
      .play-btn {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .match-ico {
        position: absolute;
        width: 32px;
        height: 32px;
        right: 10px;
        bottom: 100px;
      }

      .img-container {
        position: relative;
        display: inline-block;
        width: fit-content;
        img {
          display: block;
          width: 100%;
          height: auto;
        }

        &:hover::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(128, 128, 128, 0.4);
          pointer-events: none;
          border-radius: 10px;
        }

        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(128, 128, 128, 0.05);
          pointer-events: none;
          border-radius: 10px;
        }

        .masonry-image {
          width: 100%;
          display: block;
          object-fit: contain;
          border-radius: 10px;
        }
      }

      .item-content {
        padding: 15px 5px;
        .title {
          font-size: 16px;
          color: #000000;
        }
        .bottom-box {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;

          .bottom-item {
            display: flex;
            align-items: center;
            &:nth-child(2) {
              margin-left: 10px;
              margin-right: 10px;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }

          .views-box {
            display: flex;
            align-items: center;
          }

          .comment-box {
            display: flex;
            align-items: center;
          }

          .like-box {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  /* 响应式调整列数 */
  @media (max-width: 768px) {
    .masonry-container {
      --columns: 2;
    }
  }

  @media (max-width: 480px) {
    .masonry-container {
      --columns: 1;
    }
  }
  /**瀑布流样式结束 */
}
@media (min-width: 1280px) and (max-width: 1679px) {
  .container {
    padding: 0 5px 0 27px;
    .scroll-top {
      position: fixed;
      bottom: 230px;
      right: 34px;
      width: 46px;
      height: 46px;
      cursor: pointer;
    }

    .info-container {
      width: 100%;
      margin-top: 36px;
      .user {
        .avatar {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-right: 18px;
        }
        .info {
          .name {
            font-size: 18px;
          }
          .job-location {
            font-size: 12px;
            span {
              margin-right: 18px;
            }
          }
          .fans-info {
            font-size: 12px;
            span {
              font-size: 14px;
              margin-right: 18px;
            }
          }
        }
      }
      .btn-box {
        font-size: 12px;
        button {
          border-radius: 9px;
          &:nth-child(1) {
            margin-right: 18px;
          }
          &:nth-child(2) {
            img {
              width: 19.8px;
              height: 19.8px;
              margin-right: 9px;
            }
          }
        }
      }
    }
    .btn-container {
      margin-top: 31.5px;
      height: 180px;
      .design,
      .add-post {
        flex: 1 0 500px;
        height: 100%;
        background-size: 100% 100%;
        margin-right: 18px;
        padding: 17px;
        .bg {
          width: 350px;
        }
        .content {
          .title {
            font-size: 16px;
          }
          .desc {
            margin-top: 9px;
            font-size: 12px;
            margin-bottom: 20px;
          }

          .btn {
            font-size: 12px;
          }
        }
      }
    }

    .tool-wrap {
      margin-top: 36px;
      .tabs-box {
        font-size: 16px;
        .tabs-item {
          margin-right: 27px;
          span {
            font-size: 14px;
          }
        }
      }
      .search {
        width: 270px;
        height: 45px;
        border-radius: 22.5px;
        .icon-search {
          width: 18px;
          height: 18px;
          margin-right: 18px;
        }
        .input {
          width: calc(100% - 36px);
          height: 100%;
          line-height: 45px;
          border-radius: 22.5px;
          padding-left: 18px;
          padding-right: 9px;
          font-size: 12px;
        }
      }
    }

    .title {
      font-size: 16px;
    }

    .list {
      padding: 27px 0 72px 0;
      .item {
        width: 216px;
        margin-right: 18px;
        margin-bottom: 18px;
        .image {
          width: 216px;
          height: 216px;
        }
        .name {
          margin-top: 13.5px;
          font-size: 12px;
        }
        .time {
          margin-top: 9px;
          font-size: 10px;
        }
        .mask {
          display: none;
        }
        &:hover {
          .mask {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 216px;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon-mag {
              position: absolute;
              width: 36px;
              height: 36px;
              top: 86.4px;
              left: 89.1px;
            }
            .icon-edit {
              width: 27px;
              height: 27px;
              top: 9.9px;
              right: 42.3px;
            }
            .icon-delete {
              width: 27px;
              height: 27px;
              bottom: 9.9px;
              right: 9.9px;
              position: absolute;
            }
          }
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
    .kefu-box {
      position: fixed;
      top: 500px;
      right: 5px;
      .kefu-item {
        position: relative;
        margin-bottom: 10px;
        width: 70px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 5px 0px #cbc5c5;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .kefu {
          width: 60px;
          height: 60px;
        }
        .badge {
          background-color: #f34d37;
          border-radius: 10px;
          color: #fff;
          display: inline-block;
          font-size: 12px;
          height: 18px;
          line-height: 18px;
          padding: 0 6px;
          text-align: center;
          white-space: nowrap;
          border: 1px solid #fff;
          position: absolute;
          top: -5px;
          right: -5px;
        }
      }
    }

    /**瀑布流样式开始 */
    .masonry-container {
      max-width: 1368px;
      margin: 0 auto;
      .masonry-item {
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        width: 212.4px;
        cursor: pointer;
        position: relative;
        .remove-collect {
          display: none;
        }
        &:hover .remove-collect {
          position: absolute;
          background: rgba(0, 0, 0, 0.4);
          color: white;
          font-size: 14px;
          line-height: normal;
          padding: 4px 14px;
          border-bottom-right-radius: 10px;
          border-top-left-radius: 10px;
          display: flex;
          align-items: center;
        }
        .play-btn {
          width: 30px;
          height: 30px;
          position: absolute;
          top: 10px;
          right: 10px;
        }
        .match-ico {
          position: absolute;
          width: 32px;
          height: 32px;
          right: 10px;
          bottom: 100px;
        }
        .masonry-image {
          width: 100%;
          display: block;
          object-fit: contain;
          border-radius: 10px;
        }

        .item-content {
          padding: 15px 5px;
          .title {
            font-size: 16px;
            color: #000000;
          }
          .bottom-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;

            .bottom-item {
              display: flex;
              align-items: center;
              &:nth-child(2) {
                margin-left: 10px;
                margin-right: 10px;
              }
              img {
                width: 20px;
                height: 20px;
              }
            }

            .views-box {
              display: flex;
              align-items: center;
            }

            .comment-box {
              display: flex;
              align-items: center;
            }

            .like-box {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }

    /* 响应式调整列数 */
    @media (max-width: 768px) {
      .masonry-container {
        --columns: 2;
      }
    }

    @media (max-width: 480px) {
      .masonry-container {
        --columns: 1;
      }
    }
    /**瀑布流样式结束 */
  }
}
@media (max-width: 1279px) {
  .container {
    padding: 0 56px 0 24px;
    .scroll-top {
      position: fixed;
      bottom: 130px;
      right: 34px;
      width: 46px;
      height: 46px;
      cursor: pointer;
    }

    .info-container {
      width: 100%;
      margin-top: 32px;
      .user {
        .avatar {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          margin-right: 16px;
        }
        .info {
          .name {
            font-size: 16px;
          }
          .job-location {
            font-size: 10px;
            img {
              width: 15px;
              height: 15px;
            }
            span {
              margin-right: 16px;
            }
          }
          .fans-info {
            font-size: 12px;
            span {
              font-size: 14px;
              margin-right: 16px;
            }
          }
        }
      }
      .btn-box {
        font-size: 12px;
        button {
          border-radius: 10px;
          &:nth-child(1) {
            margin-right: 16px;
          }
          &:nth-child(2) {
            img {
              width: 17.6px;
              height: 17.6px;
              margin-right: 8px;
            }
          }
        }
      }
    }
    .btn-container {
      margin-top: 28px;
      height: 160px;
      .design,
      .add-post {
        flex: 1 0 420px;
        height: 100%;
        margin-right: 16px;
        padding: 20px;
        .bg {
          width: 270px;
        }
        .content {
          .title {
            font-size: 14px;
          }
          .desc {
            margin-top: 8px;
            font-size: 12px;
            color: #1a1a1a;
            margin-bottom: 24px;
          }

          .btn {
            font-size: 12px;
          }
        }
      }
    }

    .tool-wrap {
      margin-top: 32px;
      .tabs-box {
        font-size: 16px;
        .tabs-item {
          margin-right: 24px;
          span {
            font-size: 14px;
          }
        }
      }
      .search {
        width: 240px;
        height: 40px;
        border-radius: 25px;
        .icon-search {
          width: 16px;
          height: 16px;
          margin-right: 16px;
        }
        .input {
          width: calc(100% - 32px);
          height: 100%;
          line-height: 40px;
          border-radius: 25px;
          padding-left: 16px;
          padding-right: 8px;
          font-size: 12px;
        }
      }
    }

    .title {
      font-size: 16px;
    }

    .list {
      padding: 24px 0 64px 0;
      .item {
        width: 192px;
        margin-right: 16px;
        margin-bottom: 16px;
        .image {
          width: 192px;
          height: 192px;
        }
        .name {
          margin-top: 12px;
          font-size: 12px;
        }
        .time {
          margin-top: 8px;
          font-size: 12px;
        }
        &:hover {
          .mask {
            height: 192px;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon-mag {
              position: absolute;
              width: 32px;
              height: 32px;
              top: 76.7px;
              left: 79.2px;
            }
            .icon-edit {
              width: 24px;
              height: 24px;
              top: 8.8px;
              right: 37.6px;
            }
            .icon-delete {
              position: absolute;
              width: 24px;
              height: 24px;
              bottom: 8.8px;
              right: 8.8px;
            }
          }
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
    .kefu-box {
      position: fixed;
      top: 500px;
      right: 5px;
      .kefu-item {
        position: relative;
        margin-bottom: 10px;
        width: 70px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 5px 0px #cbc5c5;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .kefu {
          width: 60px;
          height: 60px;
        }
        .badge {
          background-color: #f34d37;
          border-radius: 10px;
          color: #fff;
          display: inline-block;
          font-size: 12px;
          height: 18px;
          line-height: 18px;
          padding: 0 6px;
          text-align: center;
          white-space: nowrap;
          border: 1px solid #fff;
          position: absolute;
          top: -5px;
          right: -5px;
        }
      }
    }

    /**瀑布流样式开始 */
    .masonry-container {
      max-width: 1216px;
      margin: 0 auto;
      .masonry-item {
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        margin-bottom: 16px;
        width: 188.8px;
        cursor: pointer;
        position: relative;
        .remove-collect {
          display: none;
        }
        &:hover .remove-collect {
          font-size: 12px;
          padding: 3.2px 11.2px;
        }
        .play-btn {
          width: 24px;
          height: 24px;
          top: 8px;
          right: 8px;
        }
        .match-ico {
          width: 25.6px;
          height: 25.6px;
          right: 8px;
          bottom: 80px;
        }
        .masonry-image {
          width: 100%;
          border-radius: 10px;
        }

        .item-content {
          padding: 12px 4px;
          .title {
            font-size: 14px;
          }
          .bottom-box {
            margin-top: 8px;
            .bottom-item {
              &:nth-child(2) {
                margin-left: 8px;
                margin-right: 8px;
              }
              img {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }

    /* 响应式调整列数 */
    @media (max-width: 768px) {
      .masonry-container {
        --columns: 2;
      }
    }

    @media (max-width: 480px) {
      .masonry-container {
        --columns: 1;
      }
    }
    /**瀑布流样式结束 */
  }
}
</style>
